import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';

import {
    addSelectedTableRow as addSelectedTimesheet,
    removeSelectedTableRow as removeSelectedTimesheet
    // @ts-ignore
} from 'services/selectedTableCells/actions';
import {
    makeSelectIsRowSelected,
    makeSelectAreSomeRowsSelected
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

interface OwnProps {
    rowId: number;
}

interface ConnectedProps {
    checked?: boolean;
    indeterminate?: boolean;
}

interface DispatchProps {
    addSelectedTimesheet: Function;
    removeSelectedTimesheet: Function;
}

export type Props = ConnectedProps & DispatchProps & OwnProps;

export class TimesheetCheckboxComponent extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLInputElement>): void => {
        event.stopPropagation();

        const { props } = this;
        const { rowId, checked, indeterminate } = props;

        if (checked || indeterminate) {
            props.removeSelectedTimesheet(rowId);
        } else {
            props.addSelectedTimesheet(rowId);
        }
    };

    render(): React.ReactElement {
        const { checked, rowId, indeterminate } = this.props;

        return (
            <Checkbox
                id={rowId}
                onClick={this.handleClick}
                checked={checked}
                indeterminate={!checked && indeterminate}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    checked: makeSelectIsRowSelected(),
    indeterminate: makeSelectAreSomeRowsSelected()
});

export default connect(
    mapStateToProps,
    {
        addSelectedTimesheet,
        removeSelectedTimesheet
    }
)(TimesheetCheckboxComponent);
